import mapperFareTypeRules from "./mapperFareTypeRules"
import type { BookingId } from "../../../../../../../types/primitiveTypes"
import type { MappedFareTypeRulesInput } from "./types"
import { transport } from "../../../../../../../services/api/transport"

const fetchFareTypeRules = (bid: BookingId): Promise<MappedFareTypeRulesInput> =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/fare_type_rules`, null, null, 3).then(
    mapperFareTypeRules,
  )

export default fetchFareTypeRules
